module.exports = __webpack_public_path__ + "img/virtual_tour.0de27bd2.jpg";